export default __webpack_public_path__ + "static/media/pic1.464f3658.jpg";